"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardMetric = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _Graphic = require("../../atoms/Graphic");

var _dashboardMetricUtils = require("./dashboardMetricUtils");

var _jsxRuntime = require("react/jsx-runtime");

var DashboardMetric = function DashboardMetric(_ref) {
  var _Object$values;

  var label = _ref.label,
      description = _ref.description,
      _ref$dataObject = _ref.dataObject,
      dataObject = _ref$dataObject === void 0 ? {} : _ref$dataObject,
      _ref$indexAxis = _ref.indexAxis,
      indexAxis = _ref$indexAxis === void 0 ? "y" : _ref$indexAxis,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "bar" : _ref$type,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? "x" : _ref$scale,
      _ref$displayScale = _ref.displayScale,
      displayScale = _ref$displayScale === void 0 ? false : _ref$displayScale,
      _ref$displayLegend = _ref.displayLegend,
      displayLegend = _ref$displayLegend === void 0 ? false : _ref$displayLegend,
      _ref$showPercent = _ref.showPercent,
      showPercent = _ref$showPercent === void 0 ? false : _ref$showPercent,
      borderColor = _ref.borderColor,
      total = _ref.total,
      totalFiltered = _ref.totalFiltered;
  var labels = type === "doughnut" ? Object.entries(dataObject).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return key !== "NS" && "".concat((0, _dashboardMetricUtils.getFullStatus)(key), " (").concat(value, ")");
  }) : Object.keys(dataObject);
  var newObject = type === "doughnut" ? (0, _dashboardMetricUtils.removeOldStatus)(dataObject) : dataObject;
  var values = (_Object$values = Object.values(newObject)) !== null && _Object$values !== void 0 && _Object$values.length ? Object.values(newObject) : [0];
  var colorsArray = Object.keys(newObject).map(function (key) {
    return key !== "NS" && (0, _dashboardMetricUtils.getStatusColor)(key);
  });
  var data = {
    labels: labels,
    datasets: [{
      data: values,
      backgroundColor: colorsArray,
      borderColor: borderColor
    }]
  };
  var options = {
    indexAxis: indexAxis,
    elements: {
      bar: {
        borderWidth: 2
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      tooltip: {
        callbacks: {
          label: function label(_ref4) {
            var _dataset$data;

            var dataset = _ref4.dataset,
                element = _ref4.element;
            var sum = dataset === null || dataset === void 0 ? void 0 : (_dataset$data = dataset.data) === null || _dataset$data === void 0 ? void 0 : _dataset$data.reduce(function (accumulator, value) {
              return accumulator + value;
            }, 0);
            var raw = element.$context.raw;
            var operation = 100 * (raw / sum);
            var percent = "".concat(((operation + "").includes(".") ? (100 * (raw / sum)).toFixed(2) : 100 * (raw / sum)) + "%", " - ").concat(raw);
            return showPercent ? percent : raw;
          }
        }
      },
      legend: {
        position: "right",
        display: displayLegend,
        labels: {
          usePointStyle: true,
          boxWidth: 8
        }
      },
      counter: {
        fontFamily: "sans-serif",
        fontSize: 25,
        fontColor: "#707070",
        textAlign: "center",
        value: totalFiltered / total * 100 || 0
      }
    },
    scales: (0, _defineProperty2.default)({}, scale, {
      ticks: {
        display: displayScale
      }
    }),
    showTooltips: true
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "text-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: description
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "select-container"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "graphic-cotainer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Graphic.Graphic, {
        data: data,
        options: options,
        type: type
      })
    }), type === "line" && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "x-label",
      children: "Fechas"
    }), type === "line" && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "y-label",
      children: "Productos"
    })]
  });
};

exports.DashboardMetric = DashboardMetric;